import { useTheme } from 'styled-components';
import { Text, useTranslation } from '@packages/utils';
import { FormItem } from 'components/Base/Form';
import Checkbox from 'components/Base/Checkbox';

const AcceptTerms = ({
  registrationModalKey,
}: {
  registrationModalKey: string;
}) => {
  const theme = useTheme();

  const { t } = useTranslation({
    lng: 'translate',
  });

  return (
    <FormItem
      name="acceptedTerms"
      valuePropName="checked"
      rules={[
        {
          validator: (_, value) =>
            value
              ? Promise.resolve()
              : Promise.reject(
                  new Error(t(`${registrationModalKey}.AGREE_TERMS_ERROR`)),
                ),
        },
      ]}
    >
      <Checkbox data-cy="registration-accept-terms">
        {t(`${registrationModalKey}.AGREE_TERMS_AND_PRIVACY_CHECKBOX_TEXT`)}
        &nbsp;
        <a
          target="_blank"
          href="https://www.idahoaeyc.org/privacy-policy"
          rel="noreferrer"
        >
          <Text
            fontWeight={theme.fontWeightMedium}
            color={theme.colorPrimaryDefaultNew}
          >
            {t(`${registrationModalKey}.PRIVACY_POLICY`)}&nbsp;
          </Text>
        </a>
        {t(`${registrationModalKey}.AND`)}&nbsp;
        <a
          target="_blank"
          href="https://www.idahoaeyc.org/terms-service"
          rel="noreferrer"
        >
          <Text
            fontWeight={theme.fontWeightMedium}
            color={theme.colorPrimaryDefaultNew}
          >
            {t(`${registrationModalKey}.TERMS_OF_SERVICE`)}
          </Text>
        </a>
      </Checkbox>
    </FormItem>
  );
};

export default AcceptTerms;
